import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";
import img from "./img/image.png";

const Image = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: "500px",
  height: "auto",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
  },
}));

const TextSection1 = () => {
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 6, md: 10 },
          py: { xs: 4, sm: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="space-between"
          direction={isMobile ? "column-reverse" : "row"}
        >
          {/* Text Content */}
          <Grid item xs={12} md={6}>
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              Get Started with{" "}
              <span
                style={{
                  color: "#28568f",
                  fontWeight: "bold",
                  fontSize: "30px",
                  fontSize: "43px",
                }}
              >
                VertexSuite
              </span>{" "}
              Platform
            </Typography>

            <Typography
              variant="body1"
              sx={{
                mb: 3,
                color: "#333",
                fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "22px" },
                lineHeight: 1.6,
              }}
            >
              Broadcast & Automate Messages, Enable Multi-Human Live Chat
              Support, Install A.I. Chatbots & more
            </Typography>

            <Button
              variant="contained"
              sx={{
                mt: 1,
                backgroundColor: "#28568f",
                color: "white",
                fontWeight: "bold",
                px: 3,
                py: 1.2,
                borderRadius: "8px",
                transition: "all 0.3s ease",
                "&:hover": { transform: "scale(1.05)" },
              }}
            >
              Get Started Now
            </Button>
          </Grid>

          {/* Image Section */}
          <Grid item xs={12} md={6} textAlign="center">
            <Image src={img} alt="VertexSuite WhatsApp Integration" />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default TextSection1;
